import React from "react"
import PropTypes from "prop-types"
import SanityBlockContent from "@sanity/block-content-to-react"
import deepMerge from "deepmerge"
import slugify from "slugify"
import markupSuperscripts from "lib/markupSuperscripts"

const BlockContent = ({ children, serializers = {}, ...props }) => (
  <SanityBlockContent
    blocks={children}
    serializers={deepMerge(standardSerializers, serializers)}
    projectId={process.env.GATSBY_SANITY_PROJECT_ID}
    dataset={process.env.GATSBY_SANITY_DATASET}
    // Ensure that className prop has a DOM element to apply to
    renderContainerOnSingleChild={true}
    {...props}
  />
)

export default BlockContent

BlockContent.propTypes = {
  children: PropTypes.array.isRequired,
  serializers: PropTypes.object,
  imageOptions: PropTypes.object,
}

const BlockRenderer = props => {
  const { style = "normal" } = props.node

  // Mark-up superscripts and add ID attributes to headings
  if (
    /^h\d/.test(style) &&
    Array.isArray(props.node.children) &&
    props.node.children.length === 1
  ) {
    const content =
      typeof props.node.children[0] === "string"
        ? props.node.children[0]
        : props.node.children[0].text

    const slug = slugify(content, { lower: true, remove: /[^a-zA-Z0-9 -]/g })

    return React.createElement(style, {
      dangerouslySetInnerHTML: {
        __html: markupSuperscripts(content),
      },
      id: /^[a-z]/.test(slug) ? slug : `jump-to-${slug}`,
    })
  }

  // Fall back to default handling
  return SanityBlockContent.defaultSerializers.types.block(props)
}

/* eslint-disable react/prop-types */
const Superscript = props => <sup>{props.children}</sup>
const Subscript = props => <sub>{props.children}</sub>
/* eslint-enable react/prop-types */

const standardSerializers = {
  types: {
    block: BlockRenderer,
  },
  marks: {
    sup: Superscript,
    sub: Subscript,
  },
}
